import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownLong, faArrowUpLong } from '@fortawesome/free-solid-svg-icons';
type Props = {
  orderBy?: 'hotelName' | 'cheapestPrice' | undefined | null;
  orderByAsc?: boolean | null | undefined;
  onOrderChange: (orderBy: string, orderByAsc: boolean) => void;
};

const OrderConfig = [
  {
    key: 'cheapestPrice',
    name: 'Price',
  },
  {
    key: 'hotelName',
    name: 'Hotel Name',
  },
];
export default function OrderByBtns({ orderBy = 'cheapestPrice', orderByAsc = true, onOrderChange }: Props) {
  return (
    <div>
      <div className="btn-group rounded-100">
        {OrderConfig.map(btn => {
          const isActive = orderBy === btn.key;
          const btnClass = isActive ? 'bg-blue-1 text-white' : 'bg-blue-1-05 text-blue-1';
          return (
            <button
              className={`button -blue-1 h-40 px-20 rounded-0 text-15 ${btnClass}`}
              key={btn.key}
              onClick={() => {
                if (isActive) {
                  onOrderChange(btn.key, !orderByAsc);
                } else {
                  onOrderChange(btn.key, true);
                }
              }}
            >
              <FontAwesomeIcon icon={isActive ? (orderByAsc ? faArrowDownLong : faArrowUpLong) : faArrowDownLong} className="text-14 mr-10" />
              {btn.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
